<template>
  <section id="Demand">
    <div class="demand-inner">
      <div class="four">
        <div class="four-left">
          <h2>无国界接触新客户</h2>
          <p>
            借助Xport对全球需求的实时捕捉与智能匹配能力，您的产品将通过多平台、多语言、多渠道同步触达海外消费者，无缝连接Amazon、Lazada、Shopee、eBay、TikTok
            Shop等主流电商平台及社交媒介，实现从“人找货”到“货找人”的转变。Xport利用AI推荐系统与精准人群画像，帮助您快速识别潜在客户群体，打破地域壁垒，拓展新市场，让您的品牌真正实现无国界获客、全球销售。
          </p>
        </div>
        <div class="four-right">
          <img src="@/assets/platform/four-1.png" alt="" />
        </div>
      </div>
      <div class="five">
        <div class="five-left">
          <img src="@/assets/platform/send-map.svg" alt="" />
        </div>
        <div class="five-right">
          <h2>利用全球购物者的专属社区</h2>
          <p>
            借助Xport构建的全球购物者专属社区，您的品牌将直接接入覆盖欧美、东南亚、中东等地区的活跃电商消费者网络。通过平台策划的专属促销活动、跨境节日营销与联动直播带货，您的产品可精准触达数百万跨境买家；同时，Xport的独家“全球需求生成计划”整合用户兴趣标签与购买行为数据，智能推荐匹配高潜力人群，让品牌在目标市场迅速引爆，实现高效获客与持续转化，为全球扩张注入源源不断的真实需求动能。
          </p>
        </div>
      </div>
      <div class="six">
        <div class="six-left">
          <h2>扩大你的数字营销</h2>
          <p>
            借助Xport的全球需求驱动与A-Z数字营销收购服务，您可以在具有高增长潜力的市场中精准锁定目标人群，开展本地化、多语种、跨平台的营销活动。平台结合全面的媒体组合策略（社交广告、搜索引擎营销、KOL合作及内容种草）与当地消费者行为分析，基于数字趋势与文化偏好，制定贴合本地的营销语言与视觉表达，不仅有效提升品牌曝光与流量转化，更实现全球客户群的快速扩张与市场份额的稳步增长。
          </p>
        </div>
        <div class="six-right">
          <img src="@/assets/platform/disc.svg" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Demand',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="less">
#Demand {
  padding: 0 5%;
  background-color: #fff;
  .demand-inner {
    width: 1140px;
    margin: 0 auto;
    padding-top: 125px;
    .four,
    .five,
    .six {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
    }
    .four-left {
      // width: 436px;
      line-height: 1.7;
      flex: 1;
    }
    .four-right {
      flex: 1;
      // width: 645px;
    }
    .five-left {
      width: 654px;
      height: 660px;
    }
    .five-right {
      width: 436px;
    }
    .six-left {
      width: 545px;
    }
    .six-right {
      width: 545px;
      height: 551px;
    }
    h2 {
      font-size: 36px;
    }
    p {
      margin-top: 20px;
      line-height: 1.7;
    }
    img {
      width: 100%;
      border-radius: 25px;
    }
  }
}
</style>
